/*
 * @Author:  
 * @Date: 2023-02-28 11:05:38
 * @LastEditors:  
 * @LastEditTime: 2023-02-28 11:08:08
 * @FilePath: \udp6web\src\store\getters.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const getters = {
  dict: state => state.dict.dict,
  currentCity: state => state.dict.currentCity,
  userInfo: state => state.dict.userInfo,
}
export default getters
